var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCiscoBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 195.555 319.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 121.94,
    y1: 82.596,
    x2: 72.042,
    y2: 169.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#291239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#335171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3b869f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#41abc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#45c2d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47cbdd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VIVI_Panels"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "79.028 222.963 72.643 219.889 1.96 261.11 8.345 264.184 79.028 222.963",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.028 222.963 72.331 219.838 38.059 159.767 43.529 163.376 79.028 222.963",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.747 222.912 71.128 219.838 36.856 159.767 42.326 163.376 77.747 222.912",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.747 222.912 71.361 219.838 1.96 259.907 8.345 262.981 77.747 222.912",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.529 243.514 38.059 239.905 38.059 159.767 43.529 163.376 43.529 243.514",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.326 243.362 36.856 239.905 36.856 159.767 42.326 163.376 42.326 243.362",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.326,
    y: 241.702,
    width: 1.203,
    height: 1.812,
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "174.401 278.193 168.016 275.119 97.333 316.34 103.718 319.414 174.401 278.193",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.401 278.193 167.704 275.068 133.432 214.997 138.902 218.606 174.401 278.193",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.119 278.142 166.501 275.068 132.229 214.997 137.699 218.606 173.119 278.142",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.119 278.142 166.734 275.068 97.333 315.137 103.718 318.211 173.119 278.142",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.902 298.744 133.432 295.135 133.432 214.997 138.902 218.606 138.902 298.744",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.699 298.592 132.229 295.135 132.229 214.997 137.699 218.606 137.699 298.592",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.699,
    y: 296.932,
    width: 1.203,
    height: 1.812,
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 147.4 188.938 256.484 188.938 112.954 0 3.871 0 147.4",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.492,140.708l182.955,105.934c.665,.385,1.497-.095,1.497-.863V121.084c0-.712-.379-1.369-.995-1.726L3.491,13.712c-.665-.385-1.497,.095-1.497,.863v125.271c0,.356,.19,.685,.497,.863Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.938 112.866 195.555 109.046 6.618 0 0 3.821 188.938 112.866",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.938 112.866 195.555 109.046 195.555 252.629 188.938 256.45 188.938 112.866",
    fill: "#666"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.425,73.745q5.592,2.542,7.74,10.017c.566,1.969,1.126,3.937,1.869,6.536,1.052-2.416,2.079-4.362,2.823-6.61,.636-1.923,1.542-2.535,3.453-1.016,.976,.775,1.999,1.191,3.421,2.012-3.249,7.151-6.382,14.047-9.674,21.292-3.271-10.946-6.393-21.392-9.632-32.231Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.844,91.685c1.899,1.096,3.467,1.858,5.004,2.97,.513,.371,1.118,1.626,1.388,2.504,1.118,3.622,2.124,7.254,3.298,11.325,1.118-2.567,2.206-4.733,3.062-7.154,.528-1.495,1.239-1.83,2.695-.769,1.183,.862,2.393,1.418,3.935,2.308-3.258,7.16-6.378,14.015-9.683,21.278-3.29-11.01-6.424-21.5-9.699-32.462Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.351,171.655c-2.462-4.852-4.627-9.121-7.097-13.988,0,6.398,0,12.266,0,18.292-.96-.554-1.701-.982-2.55-1.472,0-8.669,0-17.253,0-25.872,3.042,6.007,6.073,11.99,9.139,18.043,3.564-2.683,6.652-5.009,9.987-7.52,0,9.001,0,17.605,0,26.384l-2.396-1.383c0-5.937,0-11.82,0-18.017-2.398,1.873-4.576,3.575-7.084,5.534Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.71,152.783c-5.709-3.337-10.333-12.306-10.282-19.942,.05-7.449,4.716-10.939,10.325-7.724,5.696,3.265,10.407,12.28,10.392,19.889-.015,7.62-4.713,11.122-10.435,7.777Zm-.104-3.599c4.359,2.621,7.893,.136,7.936-5.581,.043-5.639-3.286-12.249-7.467-14.826-4.33-2.669-7.943-.248-8.042,5.389-.101,5.762,3.258,12.424,7.573,15.019Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.97,166.789c-5.727-3.29-10.384-12.194-10.388-19.862-.004-7.596,4.739-11.143,10.434-7.802,5.61,3.291,10.239,12.153,10.283,19.684,.044,7.65-4.625,11.257-10.329,7.98Zm7.725-9.232c.047-5.757-3.378-12.431-7.675-14.958-4.316-2.537-7.825,.055-7.835,5.788-.01,5.675,3.334,12.188,7.566,14.737,4.362,2.627,7.897,.15,7.943-5.567Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.753,110.645c2.602,1.502,5.109,2.723,7.584,4.43,4.02,2.773,5.493,9.149,3.086,13.21,2.196,3.867,3.284,7.638,2.099,10.861-.88,2.392-2.553,3.152-4.915,1.92-2.565-1.338-5.138-2.934-7.853-4.502,0-8.61,0-17.06,0-25.92Zm2.643,14.954c0,3.165,0,6.067,0,9.067,.399,.336,.739,.693,1.081,.899,1.215,.732,2.437,1.513,3.646,2.091,1.866,.891,3.191-.242,3.261-2.597,.069-2.322-1.164-5.211-2.997-6.53-1.605-1.156-3.243-1.92-4.991-2.929Zm.028-10.467c0,2.631,0,4.957,0,7.428,1.446,.835,2.741,1.692,4.02,2.293,1.558,.732,2.541,.05,2.616-1.993,.081-2.215-.929-4.152-2.561-5.335-1.328-.962-2.685-1.59-4.076-2.393Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.265,115.398l-4.94-2.852c0-8.56,0-17.009,0-25.66l4.94,2.852c0,8.489,0,16.94,0,25.66Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.398,104.744c1.661,.959,3.212,1.854,4.906,2.832,0,8.52,0,16.973,0,25.641l-4.906-2.832c0-8.409,0-16.857,0-25.641Z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiscoBoard);
export default __webpack_public_path__ + "static/media/cisco-board.bcbe2a5274c540f56e58e62ab7c89d18.svg";
export { ForwardRef as ReactComponent };